export const LOCAL_STORAGE_SALE_ITEMS_KEY = '__saleItems_Slenv_'

export const SALE_STATUS = {
  VOIDED_ITEMS: -2,
  VOIDED: -1,
  UNINFORMED: 1,
  INFORMED: 2
}

export const SALE_ITEM_STATUS = {
  UNFINISHED: 0,
  FINISHED: 1
}

export const SALE_DISPATCH_STATUS = {
  UNAPPLY: 0,
  APPLY: 1
}

export const SALE_ORIGIN_TYPE = {
  ORDER: 'order',
  PROFORMA: 'proforma',
  SERVICE_ORDER: 'service_order'
}

export const SALE_ORIGIN_TYPE_NAME = {
  [SALE_ORIGIN_TYPE.ORDER]: 'Pedido',
  [SALE_ORIGIN_TYPE.PROFORMA]: 'Proforma',
  [SALE_ORIGIN_TYPE.SERVICE_ORDER]: 'O. Servicio'
}

export const SALE_ORIGIN_TYPE_ABBREVIATION = {
  [SALE_ORIGIN_TYPE.ORDER]: 'Ped.',
  [SALE_ORIGIN_TYPE.PROFORMA]: 'Prof.',
  [SALE_ORIGIN_TYPE.SERVICE_ORDER]: 'O. Serv.'
}